import type React from 'react';
import { DashboardContent } from '@/components/dashboard-content';

export const Dashboard: React.FC = () => {
  return <DashboardContent />;
};
